module.exports = __webpack_public_path__ + "img/drunk.d3b66baf.svg";